import { render } from "./ImageUploadField.vue?vue&type=template&id=52d8463d"
import script from "./ImageUploadField.vue?vue&type=script&lang=js"
export * from "./ImageUploadField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__